<template>
	<div class="section full contact">
		<div class="contact-content">
			<slide-x-left-transition>
				<div v-show="showFirst" class="left">
					<div>
						<div class="title">Address</div>
						<p>
							The Loft Offices 1, Unit 210,<br>
							Dubai Media City,<br>
							Dubai, UAE
						</p>
					</div>
					
					<div>
						<div class="title">Contact</div>
						<p>
							contact@vuepo.com<br>
							+44 7488 845195
						</p>
					</div>
				</div>
			</slide-x-left-transition>
			<slide-x-right-transition>
				<div v-show="showFirst" class="right">
					<form action="">
						<div class="form-group">
							<label for="name">Name</label>
							<input type="text" id="name">
						</div>
						<div class="form-group">
							<label for="email">Email</label>
							<input type="text" id="email">
						</div>
						<div class="form-group">
							<label for="object">Object</label>
							<input type="text" id="object">
						</div>
						<div class="form-group">
							<label for="message">Object</label>
							<textarea id="message" rows="5"></textarea>
						</div>
						<a class="button">Send</a>
					</form>
				</div>
			</slide-x-right-transition>
		</div>
		<fade-transition>
			<div v-show="showSecond" class="bottom">
				<div class="container">
					<div class="social">
						<router-link to="/contact"><span class="instagram"></span></router-link>
						<!-- <router-link to="/contact"><span class="facebook"></span></router-link> -->
					</div>
					<div class="author">
						<!-- <i>Manon Tanti</i>
						<br>
						&copy; Anthony Passant -->
					</div>
				</div>
			</div>
		</fade-transition>
	</div>
</template>

<script>
export default {
	data () {
		return {
			showFirst: false,
			showSecond: false,
			showThird: false,
		}
	},
	mounted () {
		setTimeout(() => {
			this.showFirst = true
		}, 200)
		setTimeout(() => {
			this.showSecond = true
		}, 400)
		setTimeout(() => {
			this.showThird = true
		}, 900)
	}
}
</script>